module.exports = __webpack_public_path__ + "img/deepseek.9e612e06.png";